<template>
  <section class="services">
    <Container>
      <Title tag="h2">Servicios de vigilancia de peligros geoambientales</Title>
      <Row>
        <ColumnUi md="6" lg="4" class="service">
          <div class="icon-wrapper">
            <Icon svg="folder" class="service__icon" />
          </div>
          <div class="service__info">
            <h3 class="service__title">Centro Sismológico Nacional</h3>
            <span
              ><Button
                tag="a"
                href="https://www.igp.gob.pe/servicios/centro-sismologico-nacional/"
                target="_blank"
                theme="inverted"
                >Ir al servicio</Button
              ></span
            >
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="4" class="service">
          <div class="icon-wrapper">
            <Icon svg="folder" class="service__icon" />
          </div>
          <div class="service__info">
            <h3 class="service__title">Centro Vulcanológico Nacional</h3>
            <span
              ><Button
                tag="a"
                href="https://www.igp.gob.pe/servicios/centro-vulcanologico-nacional/"
                target="_blank"
                theme="inverted"
                >Ir al servicio</Button
              ></span
            >
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="4" class="service">
          <div class="icon-wrapper">
            <Icon svg="folder" class="service__icon" />
          </div>
          <div class="service__info">
            <h3 class="service__title">
              Centro de Monitoreo de Deslizamientos y Huaicos
            </h3>
            <span
              ><Button
                tag="a"
                href="https://www.igp.gob.pe/servicios/centro-monitoreo-deslizamientos-huaicos/"
                target="_blank"
                theme="inverted"
                >Ir al servicio</Button
              ></span
            >
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
import Row from "../ui/atoms/Row.vue";
import ColumnUi from "../ui/atoms/ColumnUi.vue";
import Title from "../ui/atoms/Title.vue";
export default {
  components: {
    Container,
    Button,
    Icon,
    Row,
    ColumnUi,
    Title
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
@use "@/assets/styles/tools/_mixins.scss";
.title {
  color: variables.$text-inverted-color;
}
.services {
  padding: variables.$spacing-l 0;
  background: variables.$primary-dark-color;
  color: variables.$text-inverted-color;
}
.service {
  display: flex;
  align-items: center;
  grid-gap: 0 1.5em;
  margin-bottom: 2em;
  .icon-wrapper {
    min-width: 100px;
    height: 100px;
    background-color: variables.$background-header-color;
    border-radius: 50%;
    @include mixins.centered;
  }
  &__title {
    text-transform: uppercase;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__icon {
    height: 3em;
    fill: variables.$primary-dark-color;
    margin: 0;
  }
}
@media (min-width: variables.$lg) {
  .service {
    margin-bottom: 0;
  }
}
</style>
